module.exports = __webpack_public_path__ + "img/product.5a0ab807.png";